<div class="info-content-container">
  <div id="titleHeader" class="title-header flex-row">
    <span class="flex-1">{{ item.orgCode }} - {{ item.orgDescription }}</span>
    <button type="button" class="icon-button icon-close" (click)="goToResponsibilities(previousQuery)"></button>
  </div>
  <div class="scroll-container">
    <div class="content">
      <div class="information-container">
        <div class="statistics-title statistics-title--full">
          {{ "users.main.information" | translate }}
        </div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-1 card-cell label-span">
              <label>
                {{ (item.responsibleType === ResponsibleType.sag ? "responsible.item.sagUnit" : "responsible.item.corporateCountry") | translate }}
              </label>
              <span>{{ item.orgDescription }}</span>
            </div>
            <div class="flex-1 card-cell label-span">
              <label>
                {{ (item.responsibleType === ResponsibleType.sag ? "responsible.item.orgCode" : "responsible.item.code") | translate }}
              </label>
              <span>{{ item.orgCode }}</span>
            </div>
          </div>
          @if (item.responsibleType === ResponsibleType.rc) {
            <div class="flex-row">
              <div class="flex-1 card-cell">
                <reporting-tool-chip [value]="item.assignedCountries | sortAlphabetically" placeholder="responsible.item.assignedCountries" [readonly]="true" />
              </div>
            </div>
          }
        </div>
      </div>
      <div class="information-container">
        <div class="statistics-title statistics-title--full">
          {{ "responsible.item.executiveMember" | translate }}
        </div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <reporting-tool-user-picker placeholder="responsible.item.signFunction" [value]="mainResponsible" [readonly]="true" [multiple]="true" />
            </div>
            <div class="flex-1 card-cell">
              @if (otherResponsible?.length) {
                <reporting-tool-user-picker placeholder="responsible.item.otherFunction" [value]="otherResponsible" [readonly]="true" [multiple]="true" />
              }
            </div>
          </div>
        </div>
      </div>
      <div class="information-container">
        <div class="statistics-title statistics-title--full">
          {{ "responsible.item.executiveMember" | translate }}
        </div>
        <div class="information-content">
          <div class="flex-row">
            <div class="flex-1 card-cell">
              <reporting-tool-user-picker placeholder="responsible.item.signFunction" [value]="mainSpecialist" [readonly]="true" [multiple]="true" />
            </div>
            @if (otherSpecialists?.length) {
              <div class="flex-1 card-cell">
                <reporting-tool-user-picker placeholder="responsible.item.otherFunction" [value]="otherSpecialists" [readonly]="true" [multiple]="true" />
              </div>
            }
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
